export default __webpack_public_path__ + "static/media/oficina1.dfdbddf2.jpeg";